// extracted by css-extract-rspack-plugin
export default {"page":"ListWithUsV2-module__page","belowHero":"ListWithUsV2-module__belowHero"};